// Color schemes for dashboard charts
export const DASHBOARD_COLORS = {
  // Asset condition colors
  assetCondition: {
    good: '#0AC00A',
    fair: '#FC640A',
    poor: '#F63333',
  },

  // Work order state colors
  workOrderState: {
    open: '#3176F6',
    in_progress: '#FC640A',
    pending_review: '#F63333',
    closed: '#0AC00A',
    newly_assigned_to_me: '#0AC00A',
  },

  // Finding type colors
  findingType: {
    missed_maintenance: '#04B1AE',
    deficiency: '#FF00F5',
    defect: '#55C0EF',
    issue: '#B054DC',
  },
} as const;

export type DashboardColors = typeof DASHBOARD_COLORS;
